module.exports = __webpack_public_path__ + "media/customizations/reverie/logo-c60bb7798f09cd616ba47bf3dbef4dbb.png";